export const useElka = (lotId: number | string) => {
  const { $dayjs, $modal } = useNuxtApp()

  // Инициализация дат по умолчанию для елок
  const getDefaultDates = () => {
    const now = new Date(Date.now() + 1000 * 60 * 60 * 24)
    const startDate = new Date(2025, 11, 20)

    return {
      dateFrom: $dayjs(now).isAfter($dayjs(startDate))
        ? new Date(Date.now() + 1000 * 60 * 60 * 24)
        : startDate,
      dateTo: new Date(2026, 0, 20),
    }
  }

  // Состояние дат
  const range = useState(`elka-range-${lotId}`, () => getDefaultDates())

  // Методы
  const handleSelectDate = (lot, minRentDays) => {
    $modal.show('lots/show/date_select', {
      minRentDays: minRentDays || lot.minRentDays,
      id: lot.id,
      title: 'Дата аренды',
      confirmationMethod: handleAddressSelect,
      dates: {
        start: range.value.dateFrom,
        end: range.value.dateTo,
      },
    })
  }

  const handleAddressSelect = (e) => {
    if (e && e.start && e.end) {
      range.value.dateFrom = e.start
      range.value.dateTo = e.end
    }

    $modal.show('promo/elka/location', {
      dateFrom: range.value.dateFrom,
      dateTo: range.value.dateTo,
      lotId: Number(lotId),
      confirmationMethod: handleGetOrder,
    })
  }

  const handleGetOrder = (address) => {
    $modal.show('flow/get_order_single_lot', {
      lotId: Number(lotId),
      dateFrom: $dayjs(range.value.dateFrom).toISOString(),
      dateTo: $dayjs(range.value.dateTo).toISOString(),
      quantity: 1,
      delivery: true,
      returnDelivery: true,
      promoCode: '',
      address,
    })
  }

  return {
    range,
    handleSelectDate,
    handleAddressSelect,
    handleGetOrder,
  }
}
